import {Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import {Router } from '@angular/router';
import {Config} from '@vendor/config/config';
import {HttpClient} from '@angular/common/http';
import { SnackBarComponent } from '@vendor/shared-component/snack-bar/snack-bar.component';
declare let $: any;

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit {
  @Input() title = 'عنوان';
  @ViewChild('notifModal') notifModal: ElementRef;
  showMsgBadge = false;
  notifList: any = [];
  selectedIdForDelete = null;
  hasUnread = false;
  loading = false;
  @ViewChild(SnackBarComponent) snackBar: SnackBarComponent;
  constructor(
    private router: Router,
    private config: Config,
    private http: HttpClient) { }
  ngOnInit(): void {
    setTimeout(() => {
      const summary = JSON.parse(sessionStorage.getItem('userProfileSummery'));
      if (summary && !summary.suggestionAnswerSeen) {
        this.showMsgBadge = true;
      }
    }, 100);

    this.getList();
  }
  getUserNotif() {
    $(this.notifModal.nativeElement).modal('show');
  }
  getList() {
    this.loading = true;
    // if (localStorage.getItem('userNotif')) {
    //   this.notifList = JSON.parse(localStorage.getItem('userNotif'));
    //   this.checkForUnseen(this.notifList);
    //   this.loading = false;
    // } else {
      // const url = this.config.serverUrl + `api/v2/message?last_item_id=0`;
      const url = this.config.serverUrl + `api/v2/message?pageSize=500`;
      this.http.get(url, {})
        .subscribe(res => {
          this.loading = false;
          this.notifList = (res as any).content.data;
          const temp = JSON.parse(localStorage.getItem('seenNotif'));
          this.notifList.forEach((item) => {
            if (temp && !temp.includes(item.id)) {
              item.unread = true;
            }
            if (!temp) {
              item.unread = true;
            }
          });
          this.checkForUnseen(this.notifList);
          localStorage.setItem('userNotif', JSON.stringify(this.notifList));
        },
        err => {
          this.loading = false;
        });
    // }
  }

  checkForUnseen(list) {
    let status = false;
    list.forEach((item) => {
      if (item.unread) {
        status = true;
        this.hasUnread = true;
        return;
      }
    });
    this.hasUnread = status;
  }

  deleteUserNotif() {
    $('#confirmModal').modal('hide');
    let url  = '';
    if (this.selectedIdForDelete === 'all') {
      url = this.config.serverUrl + `api/v2/message/deleteAll`;
    } else {
      url = this.config.serverUrl + `api/v2/message/delete/${this.selectedIdForDelete}`;
    }
    this.http.get(url, {})
      .subscribe((res: any) => {
        if (res.code === 0) {
          localStorage.removeItem('userNotif');
          this.getList();
          $('#alert').modal('show');
        } else {
        }
      },
      (err: any) => {
      });
  }
  goToAdvertisment(item) {
    const tempNotif = JSON.parse(localStorage.getItem('userNotif'));
    tempNotif.forEach((notif) => {
      if (notif.id == item.id) {
        notif.unread = false;
      }
    });
    localStorage.setItem('userNotif', JSON.stringify(tempNotif));
    if (localStorage.getItem('seenNotif')) {
      const temp = JSON.parse(localStorage.getItem('seenNotif'));
      temp.push(item.id);
      localStorage.setItem('seenNotif', JSON.stringify(temp));
    } else {
      const temp = [];
      temp.push(item.id);
      localStorage.setItem('seenNotif', JSON.stringify(temp));
    }
    $(this.notifModal.nativeElement).modal('hide');
    this.checkForUnseen(this.notifList);
    this.router.navigate([`/notification/${item.id}`]);
  }
  openConfirmModal(id) {
    if (id === 'all' && !this.notifList.length) {
      return;
    }
    this.selectedIdForDelete = id;
    $('#confirmModal').modal('show');
  }
}
